import { HttpApi, LocalApi, type KlukkaApi } from '@klukka/client';

/**
 * The single API instance for this portal.
 *
 * The adapter is chosen at *build* time, not run time. Vite folds
 * `import.meta.env.VITE_API_MODE` into a literal, so a production build
 * compiled with `VITE_API_MODE=http` drops the browser-storage adapter and its
 * demo seed — including the demo kennitölur — out of the bundle entirely,
 * rather than shipping them behind a flag that happens to be off.
 *
 * The demo affordances below work the same way: opt-in on the literal string
 * `true`, so a build that configures nothing is the safe one.
 */
export const api: KlukkaApi =
  import.meta.env.VITE_API_MODE === 'http'
    ? new HttpApi(import.meta.env.VITE_API_URL ? { baseUrl: import.meta.env.VITE_API_URL } : {})
    : new LocalApi({
        ...(import.meta.env.VITE_TODAY ? { today: import.meta.env.VITE_TODAY } : {}),
        revealOtp: import.meta.env.VITE_REVEAL_OTP === 'true',
      });

export const showDemoHints = import.meta.env.VITE_DEMO_HINTS === 'true';
